import {
    Component,
    OnInit,
    OnDestroy,
    Renderer2,
    HostBinding
} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import {AppService} from '@services/app.service';
import {AuthService} from '@services/auth.service';
import { Router } from '@angular/router';
import { Md5 } from 'ts-md5//dist/md5';



@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
   // @HostBinding('class') class = 'login-box';
    public loginForm: FormGroup;
    public isAuthLoading = false;
    public isGoogleLoading = false;
    public isFacebookLoading = false;

    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private appService: AppService,
        private authService: AuthService, 
        private router: Router,
        private spinnerService: NgxSpinnerService
    ) {}

    ngOnInit() {
        this.renderer.addClass(
            document.querySelector('app-root'),
            'login-page'
        );
        this.loginForm = new FormGroup({
            userId: new FormControl(null, Validators.required),
            password: new FormControl(null, Validators.required)
        });
    }

    async loginByAuth() {
        if (this.loginForm.valid) {
            this.isAuthLoading = true;
            this.spinnerService.show();
            
            
           // console.log(this.loginForm.value)
           // let password = Md5.hashStr(this.loginForm.get('password').value);
           // this.loginForm.controls['password'].setValue(password)
           // await this.appService.loginByAuth(this.loginForm.value);
           this.authService.login(this.loginForm.value)      
      .subscribe(
        result => {
          
            this.authService.getUserDetails(this.loginForm.get('userId').value).subscribe(res=>{
                this.spinnerService.hide();
               //this.spinnerService.hide(); 
               
                if(res[0].role)
                localStorage.setItem('ROLE', res[0].role);
                localStorage.setItem('USER_NAME', res[0].userId);
                localStorage.setItem('STATE', res[0].stateCode);
                localStorage.setItem('STATENAME', res[0].stateName);
                localStorage.setItem('REGIONCODE', res[0].regionCode);
                localStorage.setItem('REGIONNAME', res[0].regionName);
                //this.isLoggedIn = true;
                this.isAuthLoading = false;
              if(this.authService.getRole()=='USER')
                this.router.navigate(['fsw-dashboard'])
              else if(this.authService.getRole()=='ADMIN'||this.authService.getRole()=='PMU')
                this.router.navigate(['admin-dashboard'])
                else if(this.authService.getRole()=='RO')
                this.router.navigate(['reg-dashboard'])
                else if(this.authService.getRole()=='SO')
                this.router.navigate(['so-dashboard'])
                else if(this.authService.getRole()=='IT-TEAM')
                this.router.navigate(['it-dashboard'])



            
          },
          
          )
          //this.router.navigate(['/FSW-DASHBOARD'])
          
        },(error) => { 
        
           // console.log(error)
           this.isAuthLoading = false;
            this.toastr.error('Incorrect username or password!');
            this.spinnerService.hide();

         }     
       //err => this.error = 'Could not authenticate'
      );
            
        } else {
            this.toastr.error('Form is not valid!');
        }
    }
    

    async loginByGoogle() {
        this.isGoogleLoading = true;
        await this.appService.loginByGoogle();
        this.isGoogleLoading = false;
    }

    async loginByFacebook() {
        this.isFacebookLoading = true;
        await this.appService.loginByFacebook();
        this.isFacebookLoading = false;
    }

    ngOnDestroy() {
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'login-page'
        );
    }
}
